import { Automation } from 'src/models/Automations/automation';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from '../shared/emptyObserverCreator';

const automationsResource = createCollectionResource<Automation>({
  name: 'automations',
  endpoint: 'v1/orgs/:orgId/automations/:id',
  type: Automation,
  observerCreator: emptyObserverCreator,
});

export default automationsResource;
